import {produce} from 'immer';
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import {initializeEmptyConfig} from './state';
import {EvaluationExplorationConfig} from './types';

const EvaluationPlaygroundPageContext = createContext<{
  config: EvaluationExplorationConfig;
  editConfig: (fn: (draft: EvaluationExplorationConfig) => void) => void;
} | null>(null);

export const useEvaluationPlaygroundPageContext = () => {
  const res = useContext(EvaluationPlaygroundPageContext);
  if (res == null) {
    throw new Error('EvaluationPlaygroundPageContext not found');
  }
  return res;
};

const freeze = <T,>(val: T): T => {
  return produce(val, draft => {
    return;
  });
};

export const EvaluationPlaygroundPageProvider: React.FC<{
  children: React.ReactNode;
}> = ({children}) => {
  const frozenConfig = useMemo(() => {
    return freeze(initializeEmptyConfig());
  }, []);
  const [config, setConfig] =
    useState<EvaluationExplorationConfig>(frozenConfig);

  const editConfig = useCallback(
    (fn: (draft: EvaluationExplorationConfig) => void) => {
      setConfig(c => produce(c, fn));
    },
    []
  );

  return (
    <EvaluationPlaygroundPageContext.Provider value={{config, editConfig}}>
      {children}
    </EvaluationPlaygroundPageContext.Provider>
  );
};
